// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__5Qk9a","contentWrapper":"styles_contentWrapper__q86jV","content":"styles_content__0fmnv"};